import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { View } from '../../../../../components/Common/react-native-components';
import HighChartPie from '../../../../../components/Common/HighCharts/HighChartsPie';
import { getPieChartDefaultData } from '../../../constants';
import { handleHighChartsExport } from '../../../utils';

const PieChartContainer = forwardRef((props, ref) => {
  const { options = {}, tooltipComponent, value, isLowSampleSize, onChartClick, data } = props;

  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, data);

  };

  useImperativeHandle(ref, () => ({
    actionButtonClick
  }));

  return (
    <View style={{ alignItems: 'center' }}>
      <HighChartPie
        isLowSampleSize={isLowSampleSize}
        tooltipComponent={tooltipComponent}
        onChartClick={onChartClick}
        defaultOption={getPieChartDefaultData()}
        options={options}
        value={value}
        style={{ container: { width: 180, height: 280 } }}
        ref={chartRef}
      />
    </View>
  );
});

export default PieChartContainer;
